import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';
import organizationsASD from "../types/organizationsASD";

const ASDSocialObjects: FC<any> = () => {
    const getLinks = () => {
        let i = 1
        return Object.entries(organizationsASD).map(([key, value]) => (
            <div className='row m-3'>
                <hr />
                <a key={key} href={value} className="doc-link" target="_blank" rel="noreferrer">
                    <div className="h6">{i++}. {key}</div>
                </a>
            </div>

        ));
    };

    return (
        <div className="w-100 h-100 p-0 position-relative end-0">
            <h4 className="text-center m-3">Организации оказывающие помощь  детям с РАС</h4>
            {getLinks()}
        </div>
    );
};

export default observer(ASDSocialObjects);
